import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function heroImageFunction() {
	if($(".wp-block-thefuturblocks-call").length) {
		$(".wp-block-thefuturblocks-call").each(function() {
			const self = $(this),
				link = self.find("a"),
				svg = self.find("svg"),
				tl = gsap.timeline({paused:true});

			tl.fromTo(svg, {autoAlpha:0}, {autoAlpha:1, y:-20, rotation:45,duration:0.4});

			link.on("mouseenter", () => {
				tl.play();
			}).on("mouseleave", () => {
				tl.reverse();
			})
		});
	}
}

heroImageFunction();